import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { invalidateAfterMutation } from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type { FxRateDto } from "@/features/ledger/api/dto";

/**
 * Enregistre un taux de change horodaté (`POST /FxRates/add`) — réservé à
 * flashpay-superadmin / flashpay-admin.
 */
export const useCreateFxRate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["ledger", "fx-rates", "create"],
    mutationFn: (body: FxRateDto) =>
      mutateData({
        url: ledgerEndpoints.fxRates.add,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<FxRateDto>,
    onSuccess: () => {
      return invalidateAfterMutation(queryClient, [["LEDGER_FX_RATES_LIST"]], {
        resetListPage: true,
      });
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useCreateFxRate failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "ledger" }
      );
    },
  });
};
